import { OmniTooltipNextComponent } from "../../../../../shared";

export default function CampaignDetailsCard({
  dateRange,
  campaignName,
  syntheticId,
  clientCode,
  productCode,
  toggleCampaignDetailModal
}) {
  
  const infoRows = [
    {
      label: "Date Range:",
      value: dateRange,
    },
    {
      label: "Synthetic ID:",
      value: syntheticId,
    },
    {
      label: "Client Code:",
      value: clientCode,
    },
    {
      label: "Product Code:",
      value: productCode,
    },
  ];

  return (
    <div className="info-card plan-details-card">
      <div className="card-header">
        <h3 className="card-title">
          <OmniTooltipNextComponent>
            <div slot="invoker" className="plan-name-text" title={campaignName}>
              {campaignName}
            </div>
            <div slot="content">{campaignName}</div>
          </OmniTooltipNextComponent>
        </h3>
        <div className="card-arrow" onClick={toggleCampaignDetailModal}>
          <omni-icon class="is-size-1" icon-id="icon:interactive:right" />
        </div>
      </div>
      <div className="card-content">
        {infoRows.map((row, index) => (
          <div key={index} className="info-row">
            <div className="info-label">{row.label}</div>
            <div className="info-value">{row.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
